/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoApartmentConstructionType = typeof ListingDetailResponseDtoApartmentConstructionType[keyof typeof ListingDetailResponseDtoApartmentConstructionType] | null;


export const ListingDetailResponseDtoApartmentConstructionType = {
  PANEL: 'PANEL',
  BRICK: 'BRICK',
  MIXED: 'MIXED',
  SKELETAL: 'SKELETAL',
  PREFABRICATED: 'PREFABRICATED',
  OTHER: 'OTHER',
} as const;
